import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import React from 'react'
import { optionItems } from '../MoreFilterCategoryCheckbox'

const useStyles = makeStyles(() => ({
    subProperty: {
        lineHeight: '3px',
        padding: '8px 24px',
        textTransform: 'capitalize',
    },
    checkboxAlign: {
        alignItems: 'flex-start',
        paddingTop: 16,
    },
    checkboxTopPadding: {
        paddingTop: 0,
    },
    labelAlign: {
        paddingTop: 2,
    },
}))

export interface CategoryCheckboxProps {
    item: optionItems
    itemKey: string
    isSelected: boolean
    isDisabled?: boolean
    handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}
const CategoryCheckbox: React.FC<CategoryCheckboxProps> = ({
    item,
    itemKey,
    isSelected,
    isDisabled = false,
    handleChange,
}) => {
    const classes = useStyles()
    return (
        <FormControlLabel
            key={`${itemKey}-checkbox`}
            data-testid={`${itemKey}Checkbox`}
            className={clsx(classes.subProperty, classes.checkboxAlign)}
            classes={{ label: classes.labelAlign }}
            control={
                <Checkbox
                    name={item.value}
                    disabled={isDisabled}
                    color="default"
                    className={clsx(
                        `checkbox-${item.name}`,
                        classes.checkboxTopPadding
                    )}
                    checked={isSelected}
                    onChange={handleChange}
                    value={item.value}
                />
            }
            label={item.name}
        />
    )
}

export default CategoryCheckbox
